<template>
	<div class="row">
		<div class="col-xs-12">
			<ux-text-field
				label="Address Name"
				:readonly="readonly"
				:value="address.name"
				@input="updateAddress('name', $event)"
			/>

			<ux-text-field
				label="Street Address"
				:readonly="readonly"
				class="mb-1"
				:rules="rules.street1"
				:value="address.street1"
				@input="updateAddress('street1', $event)"
			/>

			<ux-text-field
				hide-label
				:readonly="readonly"
				:value="address.street2"
				@input="updateAddress('street2', $event)"
			/>
		</div>

		<div class="col-md-6">
			<ux-text-field
				label="City"
				:readonly="readonly"
				:rules="rules.city"
				:value="address.city"
				@input="updateAddress('city', $event)"
			/>
		</div>

		<div class="col-md-6">
			<ux-text-field
				label="Postal Code"
				:readonly="readonly"
				:rules="rules.postal_code"
				:value="address.postal_code"
				@input="updateAddress('postal_code', $event)"
			/>
		</div>

		<div class="col-md-6">
			<ux-select-field
				show-empty
				label="Country"
				:readonly="readonly"
				empty-text="(select country)"
				empty-value=""
				:items="$options.countries"
				item-text="name"
				item-value="code"
				:rules="rules.country"
				:value="address.country"
				@input="updateAddress('country', $event)"
			/>
		</div>

		<div class="col-md-6">
			<ux-select-field
				show-empty
				v-if="regions.list.length > 0"
				:label="regions.label"
				:readonly="readonly"
				empty-text="(select region)"
				empty-value=""
				:items="regions.list"
				item-text="name"
				item-value="code"
				:rules="rules.region"
				:value="address.region"
				@input="updateAddress('region', $event)"
			/>

			<ux-text-field
				v-else
				:readonly="readonly"
				:label="regions.label"
				:rules="rules.region"
				:value="address.region"
				@input="updateAddress('region', $event)"
			/>
		</div>

		<div v-if="includePrimaryFlags" class="col-xs-12">
			<div class="ux-checkbox-list is-vert">
				<ux-checkbox label="Is primary shipping address" v-model="isPrimaryShipping" />
			</div>
		</div>
	</div>
</template>

<script>
import regions from 'common/regions';
import { string } from 'postcss-values-parser';

export default {
	countries: regions.countries,

	props: {
		address: { required: true },
		readonly: { type: Boolean, default: false },
		includePrimaryFlags: { type: Boolean, default: false },
		addressType: {type: String, default: 'billing'},
	},

	beforeCreate() {
		this.countryRegions = structuredClone( regions.countryRegions );
	},

	data() 
	{
		return {
			rules: {
				street1: [ v => !!v || 'Please enter the street address' ],
				city: [ v => !!v || 'Please enter a city' ],
				postal_code: [ v => !!v || 'Please enter a postal code' ],
				country: [ v => !!v || 'Please select a country' ],
				region: [ v => !!v || 'Please select a province/state' ],
			},
		}
	},

	computed: {
		regions()
		{
			var titles = { CA: 'Province', US: 'State' };
			return {
				label: titles[this.address.country] || 'Region',
				list: this.countryRegions[this.address.country] || [],
			};
		},

		isPrimaryShipping: {
			get() { return this.address.is_primary_shipping || false; },
			set(flag) { this.updateAddress('is_primary_shipping', flag); },
		},

		isPrimaryBilling: {
			get() { return this.address.is_primary_billing || false; },
			set(flag) { this.updateAddress('is_primary_billing', flag); },
		},
	},

	methods: {
		updateAddress(field, value)
		{
			if (!this.readonly)
			{
				var payload = { ...this.address, [field]: value };
				
				this.$emit('update:address', payload);
			}
		},
	},
	async mounted() {
		console.log(this);

		// get Canada regions from database and remove the id property
		if (this.addressType=='shipping') {
			this.countryRegions['CA'] = await (await regions.fetchRegionList()).map( ({id, ...region}) => region );
		}

	}
}
</script>